import { render } from "./PickListMultiple.vue?vue&type=template&id=581cc004"
import script from "./PickListMultiple.vue?vue&type=script&lang=js"
export * from "./PickListMultiple.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__